var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusinessContact86(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.30469 8.66369C7.30469 4.50323 10.4021 0.0126953 15.406 0.0126953C20.4098 0.0126953 23.5072 4.50323 23.5072 8.66369C23.5072 14.8292 19.302 18.6456 15.406 18.6456C11.5099 18.6456 7.30469 14.8292 7.30469 8.66369ZM8.68359 9.36509C8.97659 14.2922 12.3049 17.3147 15.4056 17.3147C18.5064 17.3147 21.834 14.2928 22.1283 9.36709C20.1199 9.09824 18.2431 8.25111 16.7369 6.92285C14.8763 8.5692 12.5033 9.46957 9.9852 9.46957C9.55516 9.46957 9.12174 9.42765 8.68359 9.36509Z",
    fill: "#473BF0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M27.5402 22.0346L20.5204 17.8359C18.8752 19.2519 16.9086 20.0305 15.0014 20.0305C13.0943 20.0305 11.1277 19.2519 9.48245 17.8359L2.4627 22.0346C1.45207 22.6389 0.824219 23.7446 0.824219 24.9196V30.125C0.824219 30.4971 1.12667 30.798 1.49932 30.798H14.3263V24.0683C14.3263 23.6961 14.6281 23.3953 15.0014 23.3953C15.3748 23.3953 15.6765 23.6961 15.6765 24.0683V30.798H28.5035C28.8762 30.798 29.1786 30.4971 29.1786 30.125V24.9196C29.1786 23.7446 28.5508 22.6389 27.5402 22.0346Z",
    fill: "#473BF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessContact86);
export default __webpack_public_path__ + "static/media/business-contact-86.2d7bf78e1cc3367d544a088ec22e8a40.svg";
export { ForwardRef as ReactComponent };